"use client";

import React from "react";
import { AppConfig } from "@/lib/Types/AppConfig";
import { useVoucherRedemptionTracking } from "@/lib/PlatformData/hooks/useVoucherRedemptionTracking";

interface VoucherLayoutClientProps {
  children: React.ReactNode;
  appConfig: AppConfig;
}

export default function VoucherLayoutClient({
  children,
  appConfig,
}: VoucherLayoutClientProps) {
  useVoucherRedemptionTracking({
    appConfig,
    isLoading: false,
    isConfirmation: false,
  });
  return <>{children}</>;
}
